var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "advisor-search-results-block container-fluid px-0" },
    [
      _vm.filteredAdvisors.length && !_vm.isInitializing && !_vm.isLoading
        ? _c("div", { staticClass: "container" }, [
            _c("div", { staticClass: "row results-amount-title" }, [
              _c("div", {
                staticClass: "col-sm-12",
                domProps: { innerHTML: _vm._s(_vm.results) }
              })
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        [
          _vm._l(_vm.filteredAdvisors.slice(0, _vm.endIndex), function(
            advisor
          ) {
            return _c("list-item", {
              key: advisor.id,
              attrs: {
                advisor: advisor,
                selectedAdvisorClick: _vm.selectAdvisorClickFn
              }
            })
          }),
          _vm._v(" "),
          _vm.hasMoreAdvisors && !(_vm.isInitializing || _vm.isLoading)
            ? _c("div", { staticClass: "py-3 container" }, [
                _c("div", { staticClass: "row justify-content-center" }, [
                  _c(
                    "div",
                    { staticClass: "col-12 d-flex justify-content-center" },
                    [
                      _c(
                        "a",
                        {
                          staticClass: "btn btn-primary text-center",
                          attrs: { href: "javascript:;" },
                          on: { click: _vm.loadMoreClickFn }
                        },
                        [_vm._v("Load More")]
                      )
                    ]
                  )
                ])
              ])
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      !_vm.filteredAdvisors.length &&
      !_vm.isInitializing &&
      !_vm.isLoading &&
      (_vm.isDirectConsumer.length || _vm.filteredAdvisors.length == 0)
        ? _c(
            "div",
            { staticClass: "advisor-search-page-zero-results py-3 container" },
            [
              _c("div", { staticClass: "row justify-content-center" }, [
                _c("div", { staticClass: "col-12 text-center" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      _vm._s(_vm.text("advisorNameSearchNoResultsPrefix"))
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "javascript:;" },
                        on: { click: _vm.noResultsFoundFn }
                      },
                      [
                        _vm._v(
                          _vm._s(_vm.text("advisorNameSearchNoResultsLinkText"))
                        )
                      ]
                    )
                  ])
                ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.filteredAdvisors.length && (_vm.isInitializing || _vm.isLoading)
        ? _c(
            "div",
            { staticClass: "advisor-search-page-zero-results py-3 container" },
            [
              _c("div", { staticClass: "row justify-content-center" }, [
                _c("div", { staticClass: "col-12 text-center" }, [
                  _c(
                    "div",
                    {
                      staticClass: "advisor-search-results-block-loading",
                      attrs: { role: "status" }
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.text("loading")) +
                          "\n                "
                      )
                    ]
                  )
                ])
              ])
            ]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("p", [
      _c("span", { staticClass: "advisor-search-page-bold" }, [
        _vm._v(" 0 results ")
      ]),
      _vm._v("found.")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }